import React from 'react';
import {Flex} from '/app/src/component';
import style from './style.css';

class ToogleInput extends React.Component {
    constructor(props){
        super(props);
        this._renderToogles = this._renderToogles.bind(this)
        this._handleToogle = this._handleToogle.bind(this)
    }

    _handleToogle(value){
        return (event) => {
            let activeValues = this.props.active
            if(activeValues.indexOf(value) > -1){ // then we remove and call onChange handle
                activeValues = activeValues.filter((item) => item !== value)
            }else{ // then we add and call onChange
                activeValues.push(value)
            }
            event.target.value = activeValues
            event.target.name = this.props.name
            this.props.onChange(event)
        }
    }
    _renderToogles(){
        var toogles = []
        this.props.values.forEach((item) => {
            let itemStyle = style.ToogleItem
            if(this.props.active.indexOf(item.value) > -1){
                itemStyle = style.ToogleItemActive
            }
            toogles.push(
                <Flex key={item.label} className={itemStyle}
                hAlignContent='center' vAlignContent='center'
                name={item.label} onClick={this._handleToogle(item.value)}
                >
                     {item.label}
                </Flex>
            )
        })
        return toogles

    }
    render() {
        return(
            <Flex column className={style.InformationFormsWrapper} width='100%'>
                <Flex width='100%' wrap>
                    {this._renderToogles()}
                </Flex>
            </Flex>
        );
    }
}
export default ToogleInput;



// WEBPACK FOOTER //
// src/component/Forms/ToogleInput/index.js